import { h } from './pragma.mjs';
import mujKatastr from './mujKatastr.jsx';
import mujKatastrPublic from './mujKatastrPublic.jsx';
import oPortalu from './oPortalu.jsx';
import sluzby from './sluzby.jsx';
import rozcestnik from './rozcestnik/rozcestnik.jsx';

export default (aktivni, isPublic) => {
    return (
        <gov-tabs id="portal-main-tabs" class="sides-auto" type="text" wcag-label="Navigační záložky portálu">

            {rozcestnik((aktivni === 'zivotniSituace') ? 'true' : 'false')}
            { (sluzby((aktivni === 'sluzby') ? 'true' : 'false',isPublic))}

            { isPublic ? (mujKatastrPublic((aktivni === 'mujKatastr') ? 'true' : 'false', true)) : (mujKatastr((aktivni === 'mujKatastr') ? 'true' : 'false', false)) }
            {oPortalu((aktivni === 'oPortalu') ? 'true' : 'false')}

        </gov-tabs>

    )
}